import { Component, OnInit } from '@angular/core';
import { SearchTermservice } from '../../services/search/search-service.service';
import { AgentDashboardService } from '../../services/agent_dashboard/agent-dashboard.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort, Sort } from '@angular/material';
import { PageEvent } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-agent-dashboard',
  templateUrl: './agent-dashboard.component.html',
  styleUrls: ['./agent-dashboard.component.css']
})

export class AgentDashboardComponent implements OnInit {
  public agentId: any;
  public agentDetails: any;
  additionalInfo: FormGroup;
  submitSuccess;
  message;
  docsList: any;
  filteredDocsList: any = [];
  listOfDocs: any = [];
  length: any;
  pageSize = 10;
  isRed: boolean = false;
  isBlue: boolean = false;
  style: any;
  todayDate: any;
  ispaginationFlag: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  /*** Removing the MissingFile column from the Table ***/
  displayedColumns = ['DocumentName', 'DocType', 'ExpirationDate','DocumentStatus'];
  dataSource: MatTableDataSource<UserData>;
  public agentComplPercent = 0;
  public innerStrokeColor = '#d9d9d9';
  public outerStrokeColor = '#a6a6a6';
  public showPendingApproval: boolean = false;
  public agentLoc: boolean = true;
  public errMsg: any;
  public typeErr: boolean = false;
  public noResults: any;
  clientDisable: any;
  clientHidden: any;
  public role: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private searchTermservice: SearchTermservice,
    private agentDashboardService: AgentDashboardService) { }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.searchTermservice.detailsOfAgent(this.agentId).subscribe(res => {
      this.typeErr = false;
      this.agentDetails = res;
      localStorage.setItem('AgentName', this.agentDetails.name);
      this.getDocDetails();
    }, err => {
      this.errMsg = "Vendor Details Service " + err;
      this.typeErr = true;
    });

    this.agentDashboardService.load.subscribe(res => {
      if (res === 'success') {
        this.getDocDetails();
      }
    });
    this.role = localStorage.getItem("Role");
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  getDocDetails() {
    this.agentDashboardService.getAgentDetails(this.agentId).subscribe(res => {
      this.typeErr = false;
      if (res !== undefined && res !== '') {
        this.docsList = res;
        /*** The following condition is to retrieve the Agent Compliance percentage as well as show different colors based on the percentage ***/
        this.agentComplPercent = this.docsList.COMPLIANT_PERCENT;
        if (this.agentComplPercent === 100 && this.docsList.IS_VENDOR_COMPLIANT === 'Y') {
          this.innerStrokeColor = '#C7E596';
          this.outerStrokeColor = '#78C000';
        } else if (this.agentComplPercent < 100 && this.agentComplPercent > 0) {
          this.innerStrokeColor = '#ffd699';
          this.outerStrokeColor = '#ff9900';
        } else if (this.agentComplPercent <= 0) {
          this.innerStrokeColor = '#d9d9d9';
          this.outerStrokeColor = '#a6a6a6';
        }

        if (this.docsList !== undefined && this.docsList.Documents.length > 0) {
          this.noResults = '';
          var count = 0;
          for (let i = 0; i < this.docsList.Documents.length; i++) {
            if (this.docsList.Documents[i].DocumentCode === 'AGT_OTH' || this.docsList.Documents[i].DocumentCode === 'AGT_PIC') {
              //Do nothing, don't add it to Filtered List, since we don't need to display these documents.
            } else {
              this.filteredDocsList[count] = this.docsList.Documents[i];
              count++;
            }
          }
          /*** Sorting the list by DocumentName ***/
          this.filteredDocsList.sort((a, b) => {
            if (a.DocumentName < b.DocumentName) return -1;
            else if (a.DocumentName > b.DocumentName) return 1;
            else return 0;
          });

          /*** Formating the Date by MM/DD/YYYY ***/
          for (let j = 0; j < this.filteredDocsList.length; j++) {
            if (this.filteredDocsList[j].ExpirationDate !== undefined && this.filteredDocsList[j].ExpirationDate !== null
              && this.filteredDocsList[j].ExpirationDate !== "") {
              var momentDate = moment(this.filteredDocsList[j].ExpirationDate).format('YYYY/MM/DD');
              this.filteredDocsList[j].ExpirationDate = momentDate;
            }

            if (this.filteredDocsList[j].DocType !== undefined && this.filteredDocsList[j].DocType !== null
              && this.filteredDocsList[j].DocType !== "") {
              var docSPlit = this.filteredDocsList[j].DocType.split('-');
              if (docSPlit[0] === "AGENTEMPLOYEE")
                this.filteredDocsList[j].DocType = docSPlit[1] !== undefined ? 'Vendor Employee - ' + docSPlit[1] : 'Vendor Employee';
              else if (docSPlit[0] === "DUEDILIGENCE")
                this.filteredDocsList[j].DocType = 'Due Diligence';
              else if (docSPlit[0] === "INSURANCE")
                this.filteredDocsList[j].DocType = 'Insurance';
              else if (docSPlit[0] === "LICENSE")
                this.filteredDocsList[j].DocType = 'License';
              else if (docSPlit[0] === "LOCATION")
                this.filteredDocsList[j].DocType = docSPlit[1] !== undefined ? 'Location - ' + docSPlit[1] : 'Location';
            }
          }

          /*** Showing only the filtered documents ***/
          this.listOfDocs = this.filteredDocsList;
          this.dataSource = new MatTableDataSource(this.listOfDocs);
          this.dataSource.sort = this.sort;
          this.length = this.listOfDocs.length;
          if (this.length <= 10) {
            this.ispaginationFlag = false;
          } else {
            this.ispaginationFlag = true;
          }

          if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
            this.paginator.pageIndex = this.paginator.pageIndex - 1;
          }

          this.dataSource.paginator = this.paginator;
          const paginatorIntl = new MatPaginatorIntl();
          paginatorIntl.itemsPerPageLabel = 'Items per page';
          paginatorIntl.nextPageLabel = 'Next page';
          paginatorIntl.previousPageLabel = 'Previous page';
          paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            length = this.length;
            if (length == 0 || pageSize == 0) {
              return `0 van ${length}`;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
            const round = Math.ceil(length / 10)
            return `${(startIndex / 10) + 1}  of ${round}`;
          }
          this.dataSource.paginator._intl = paginatorIntl;
        } else {
          this.noResults = 'No Vendor documents are found';
        }
      } else {
      }
    }, err => {
      this.errMsg = "Vendor Documents detail service " + err;
      this.typeErr = true;
    });
  }

  convertToDate(expirationDate) {
    let currentDate = new Date();
    this.todayDate = currentDate.getMonth() + 1 + "/" + currentDate.getDate() + "/" + currentDate.getFullYear();
    if (expirationDate !== null && expirationDate !== '' && expirationDate !== "Invalid Date" && expirationDate !== undefined) {
      const expiration = new Date(expirationDate);
      if (expiration !== undefined) {
        let expDate = expiration.getMonth() + 1 + "/" + expiration.getDate() + "/" + expiration.getFullYear();
        return expDate;
      }
    }
  }
  
  getStatusColor(status) {
    if (status) {
      if (status.trim().toLowerCase().replace(/ /g, '') === 'approved') {
        return 'Statusgreen';
      } else if (status.toLowerCase().replace(/ /g, '') === 'pendingapproval') {
        return 'Statusbalck';
      } else if (status.trim().toLowerCase().replace(/ /g, '') === 'inprogress') {
        return 'Statusblue';
      } else if (status.trim().toLowerCase().replace(/ /g, '') === 'rejected') {
        return 'Statusred';
      } else {
        return 'Statusblack';
      }
    } else {
      return 'Statusblack';
    }
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }

  checkLoc(docType) {
    if (docType.includes('LOCATION-') || docType.includes('AGENTEMPLOYEE-')) {
      return ['LocationStyle1'];
    } else
      return ['LocationStyle2'];
  }

  selectedDoc(listOfDocs) {
    let str = listOfDocs.DocType;
    let res = str.split("-");
    let DocType = res[0];
    let id = res[1];
    if (str.includes('Location -')) {
      if (id !== undefined) {
        localStorage.setItem('LocationId', id);
        this.router.navigate(['agent/location', this.agentId, 'Documents', id]);
      }
    }
    if (str.includes('Vendor Employee -')) {
      if (id !== undefined) {
        if (this.role === 'PC Client') {
          this.router.navigate(['agent/agentemployee', this.agentId, 'Requirements', id]);
        } else {
          this.router.navigate(['agent/agentemployee', this.agentId, 'Documents', id]);
        }
        localStorage.setItem('EmployeeId', id);
        localStorage.setItem('dbId', listOfDocs._id !== undefined ? listOfDocs._id : '');
      }
    }
    switch (DocType) {
      case ("Due Diligence"):
        this.router.navigate(['agent/duediligence', this.agentId, 'DUEDILIGENCE']);
        break;
      case ("Vendor Employee"):
        this.router.navigate(['agent/agentemployee', this.agentId, 'AGENTEMPLOYEE']);
        break;
      case ("Location"):
        this.router.navigate(['agent/location', this.agentId, 'LOCATION']);
        break;
      case ("License"):
        this.router.navigate(['agent/license', this.agentId, 'LICENSE']);
        break;
      case ("Summary"):
        this.router.navigate(['agent/summary', this.agentId, 'SUMMARY']);
        break;
      case ("Insurance"):
        this.router.navigate(['agent/insurance', this.agentId, 'INSURANCE']);
        break;
    }
  }

  selectedLocOrEmp(docType) {
    if (docType.includes('LOCATION-')) {
      let locId = docType.split('-');
      this.router.navigate(['agent/location', this.agentId, 'Documents', locId[1]]);
    }
    if (docType.includes('AGENTEMPLOYEE-')) {
      let empId = docType.split('-');
      this.router.navigate(['agent/agentemployee', this.agentId, 'AGENTEMPLOYEE', empId[1]]);
    }
  }
}

export interface UserData {
  DocumentName: String;
  DocType: String;
  ExpirationDate: Date;
  DocumentStatus:String;
}



// WEBPACK FOOTER //
// ./src/app/components/agent-dashboard/agent-dashboard.component.ts